import { render, staticRenderFns } from "./cookie-template-layout.vue?vue&type=template&id=031222be"
import script from "./cookie-template-layout.vue?vue&type=script&lang=js"
export * from "./cookie-template-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports